import { render, staticRenderFns } from "./claimInfo.vue?vue&type=template&id=2671180a"
import script from "./claimInfo.vue?vue&type=script&lang=js"
export * from "./claimInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2671180a')) {
      api.createRecord('2671180a', component.options)
    } else {
      api.reload('2671180a', component.options)
    }
    module.hot.accept("./claimInfo.vue?vue&type=template&id=2671180a", function () {
      api.rerender('2671180a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claim/recordUsedManage/claimInfo.vue"
export default component.exports